// Fades an element in as it scrolls into view; v-reveal="150" delays it by 150ms
const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

let observer = null;
const getObserver = () => {
  observer ??= new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );
  return observer;
};

export default {
  mounted(el, { value }) {
    if (!('IntersectionObserver' in window) || prefersReducedMotion()) return;
    // already on screen at load: show it as is rather than fading it in in front of the user
    if (el.getBoundingClientRect().top < window.innerHeight) return;
    if (value) el.style.setProperty('--reveal-delay', `${value}ms`);
    el.classList.add('reveal');
    getObserver().observe(el);
  },
  unmounted(el) {
    observer?.unobserve(el);
  },
};
